import * as React from 'react';
export const IcFlightGame = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M3 14a1 1 0 00-.71.28A1 1 0 002 15v1a1 1 0 002 0v-1a1 1 0 00-.29-.68A1 1 0 003 14zm0-5a1 1 0 00.71-.28A1 1 0 004 8V7a1 1 0 00-2 0v1a1 1 0 00.29.68A1 1 0 003 9zm15 10A1 1 0 1018 21 1 1 0 0018 19zm-3-3A1 1 0 1015 18 1 1 0 0015 16zm6.81-10.58a1 1 0 00-.49-.37.94.94 0 00-.62 0 1 1 0 00-.5.35l-2.2 3h-2.2l-1.65-1.69a3.82 3.82 0 00-3.92-.94 3.62 3.62 0 00-2.45 2.61h-.06a3.25 3.25 0 00-3.08 2.24H3a1 1 0 00-.71.29 1.05 1.05 0 00-.29.71 1 1 0 00.29.71 1 1 0 00.71.29h1.64a3.32 3.32 0 001.21 1.64 3.25 3.25 0 002 .61l13.28-1.12a1 1 0 00.92-1V6a.94.94 0 00-.24-.58zm-11.9 3c.22-.34.553-.591.94-.71a1.89 1.89 0 011 0c.333.078.638.247.88.49l.25.26-3.07-.04z'
      fill='currentColor'
    />
  </svg>
);
